import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import register from "preact-custom-element";
import SwatchProductActions from "../../pdp-swatch-modal/swatch-product-actions";

function ProductFormSwatchActions({ limitEach, variantId, swatchType }) {
  const [cartData, setCartData] = useState(window.cartData);
  const [error, setError] = useState(null);

  const cartItems = cartData?.items || [];

  const onError = () => {
    setError(window.localeStrings.product.add_to_cart_error);
    setTimeout(() => {
      setError(null);
    }, 3000);
  };

  const item = cartItems.find(
    (cartItem) => parseInt(cartItem.variant_id) === parseInt(variantId),
  );

  useEffect(() => {
    const onCartUpdated = (e) => {
      setCartData(e.detail.cartData);
    };

    document.addEventListener("cart:updated", onCartUpdated);

    return () => document.removeEventListener("cart:updated", onCartUpdated);
  }, [setCartData]);

  return (
    <>
      <SwatchProductActions
        variantId={variantId}
        item={item}
        limitEach={parseInt(limitEach)}
        onError={onError}
        onAfterAdd={() => {
          document.dispatchEvent(new CustomEvent("markup-modal:close"));
          document.dispatchEvent(new CustomEvent("mini-cart:open"));
        }}
        classPrefix="product-form-swatch-actions"
        removeButtonClasses="button button--grey button--full"
        addButtonClasses="button button--black button--full"
        addToCartText={window.localeStrings.product.add_to_cart}
        removeFromCartText={window.localeStrings.product.remove_from_cart}
        swatchType={swatchType}
      />
      {error && (
        <div
          className="product-form-swatch-actions__error"
          dangerouslySetInnerHTML={{
            __html: error,
          }}
        ></div>
      )}
    </>
  );
}

if (!customElements.get("product-form-swatch-actions")) {
  register(
    ProductFormSwatchActions,
    "product-form-swatch-actions",
    ["limit-each", "variant-id", "swatch-type"],
    {
      shadow: false,
    },
  );
}
